import { call, fork, take, put } from 'redux-saga/effects'
import { bindAsyncAction } from 'typescript-fsa-redux-saga'
import { Action } from 'typescript-fsa'

import { FacebookPostApi } from '../../api/instances'

import { Severity, EventType } from '@professocial/professocialTypes/types/messageTypes'

import {
  GetFacebookFeedForPageRequest,
} from '@3m5/sm_publish-frontend-api/apis/FacebookPostApi'
import {
  getFacebookFeedForPage,
  getFacebookFeedForPageInitiated,
} from './facebook.actions'

import { requestFailed, requestFinished, requestStarted } from '../common/common.actions'
import i18n from 'i18next'

// loadFacebookFeedForPage
const loadFacebookFeedForPageWorker = bindAsyncAction(getFacebookFeedForPage)(
  function * (params: GetFacebookFeedForPageRequest) {
    return yield call([FacebookPostApi, FacebookPostApi.getFacebookFeedForPage], params)
  },
)

function * watchLoadFacebookFeedForPageInitiated () {
  while (true) {
    const action: Action<GetFacebookFeedForPageRequest> = yield take(getFacebookFeedForPageInitiated)
    yield put(requestStarted({ type: action.type }))
    try {
      yield loadFacebookFeedForPageWorker(action.payload)
      yield put(requestFinished({ type: action.type }))
    } catch (e) {
      yield put(requestFailed({
        type: action.type,
        error: e,
        message: {
          severity: Severity.error,
          message: i18n.t('coreMessages:loadingError',
            { context: i18n.t('coreDashboard:instagramPosts') }),
          eventType: EventType.load,
        },
      }))
      console.error('error in watchLoadFacebookFeedForPageInitiated: ', e)
    }
  }
}

export function * facebookSagas () {
  yield fork(watchLoadFacebookFeedForPageInitiated)
}
